// eslint-disable-next-line no-unused-vars
import React from 'react';
import { oneOfType, number, node, string } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { isNumber } from 'lodash';

import DeliveryEstimate from 'Components/Product/DeliveryEstimate';
import { NWOrderTypeBadge } from 'Components/shared';

const StyledMenuSupplier = styled.div`
  .supplierHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: calc(100% - 30px);
    margin: 0 auto;
    padding: 15px 0 5px;
    color: ${ props => props.theme.colors.darkGray };

    .supplierName {
      font-size: 16px;
      display: flex;
      gap: 10px;
      align-items: center;

      span {
        font-weight: 600;
      }
    }
  }
`;

const CartMenuSupplier = ({
  children,
  supplierId,
  supplierIndex,
  supplierOfferDeliveryTimeDays,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const showSupplierInfo = isNumber(supplierIndex);

  return (
    <StyledMenuSupplier theme={ theme }>
      { showSupplierInfo && (
        <div className="supplierHeader">
          <div className="supplierName">
            <span>{ `${ t('orders.order') } ${ supplierIndex + 1 } ` }</span>
            <NWOrderTypeBadge>
              { supplierId !== 'default' ? t('products.supplierStock') : t('products.nodStock') }
            </NWOrderTypeBadge>
          </div>
          <DeliveryEstimate estimate={ supplierOfferDeliveryTimeDays } isExternalSupplier={ supplierId !== 'default' } />
        </div>
      ) }
      { children }
    </StyledMenuSupplier>
  );
};

CartMenuSupplier.propTypes = {
  children: node,
  supplierId: oneOfType([string, number]),
  supplierIndex: oneOfType([string, number]),
  supplierOfferDeliveryTimeDays: oneOfType([string, number])
};

CartMenuSupplier.displayName = 'CartMenuSupplierComponent';

export default CartMenuSupplier;
